import template from './tooltip-icon.html';
import ICON_DEFAULT from './../../../../../images/conditions_icon.png';

const DIRECTIVE_NAME = TooltipIcon.DIRECTIVE_NAME = 'ktTooltipIcon';
export default function TooltipIcon() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TooltipIconController,
        controllerAs: 'tooltipIconCtrl',
        scope: {
            hint: `=${DIRECTIVE_NAME}`,
        },
    };
}

export function TooltipIconController() {
    const vm = this;

    Object.assign(vm, {
        icon: ICON_DEFAULT,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/tooltip-icon/tooltip-icon-component.js